import http from "../http-common";
import md5 from "md5";

const getAllStores = async () => {
  return await http
    .get("/admin/stores")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createStore = async (data) => {
  return await http
    .post("/admin/stores", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateStoreOwner = async (storeId, data) => {
  return await http
    .put(`/admin/stores/${storeId}/owner`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  stores: {
    getAll: getAllStores,
    create: createStore,
    updateOwner: updateStoreOwner,
  },
};
